module.exports = __webpack_public_path__ + "img/honor_4.2a2f8996.png";